import { isOnline, isPre, isSim } from '@/utils/common/env'
// import useCommonStore from '@/store/modules/common'

import { UAParser } from 'ua-parser-js'

// RTBO相关页面获取移动端相关埋点参数
export function getOSInfo() {
  const userAgent = navigator.userAgent
  if (/win/i.test(userAgent)) return 'window'
  if (/iphone|ipad|ipod|ios/i.test(userAgent)) return 'ios'
  if (/mac/i.test(userAgent)) return 'mac'
  if (/Android/i.test(userAgent)) return 'android'
}

export function getMobileAttrsInfo() {
  const { device } = UAParser(navigator.userAgent)
  const OS_TYPE_JSON = {
    window: 9,
    mac: 10,
    android: 2,
    ios: 1,
    default: -1,
  }
  let mobileDetail = {
    device_type: OS_TYPE_JSON[getOSInfo() || 'default'], // 设备类型
    screen_size: `${window.innerWidth},${window.innerHeight}`, // 页面尺寸
  }
  if (device.is('mobile')) {
    mobileDetail = {
      ...mobileDetail,
      device_vender: device.vendor, // 设备厂商  Samsung、Apple等
      device_model: device.model, // 设备型号  SM-G955U等
    }
  }
  return mobileDetail
}

export const Omega = window.Omega
export function trackEvent({ eventId = '', eventLabel = '', attrs = {} }) {
  // const { userInfo, shopInfo, brandInfo, roleInfo, contractorInfo } = useCommonStore()
  // const managerCommonAttrs = {
  //   pub_manager_contractor_id: contractorInfo.contractorId, // 管理端主体id（给内嵌页面的公参）
  //   pub_manager_role_type: roleInfo.roleType, // 管理端角色类型（给内嵌页面的公参）
  //   pub_manager_brand_id: brandInfo.brandId, //	管理端品牌id（给内嵌页面的公参）
  //   pub_business_type: shopInfo.businessType, // 管理端shop业态（给内嵌页面的公参）
  //   pub_manager_web_version: PACKAGE_JSON.version, //	管理端系统版本（给内嵌页面的公参）
  //   pub_manager_terminal: 1, // 管理端设备类型（给内嵌页面的公参） 1 - web, 2 - phone
  //   pub_terminal_device: 6,
  // }
  // const commonAttrs = {
  //   uid: userInfo.uid,
  //   country: contractorInfo.country,
  //   b_web_version: PACKAGE_JSON.version,
  //   terminal: 1, // 1 - web, 2 - phone
  //   contractor_id: contractorInfo.contractorId,
  //   role_type: roleInfo.roleType,
  //   brand_id: brandInfo.brandId,
  //   shop_id: shopInfo.shopId,
  //   ...managerCommonAttrs,
  // }
  const commonAttrs = {}
  // 设置全局属性公参
  Omega.setConfig({ attrs: { ...commonAttrs } })
  // 判断非测试环境再做埋点上报
  if (isOnline || isPre || isSim) {
    Omega.trackEvent(eventId, eventLabel, {
      ...attrs,
    }).then(() => {
      console.log(eventId, eventLabel, { ...commonAttrs, ...attrs })
    })
  } else {
    console.log('测试环境拦截Omega埋点上报', eventId, eventLabel, {
      ...commonAttrs,
      ...attrs,
    })
  }
}

export default {
  trackEvent,
}
